/*
Controller: InventoryIngestionDownloads

Operations:
  getImagesZip
  getBinariesZip
*/
var Api = require('../config')

var InventoryIngestionDownloads = (function () {
  /*
  Operation: getImagesZip
  Get all images as a zip file
  Parameters:
    inventoryIngestionId: Id of the inventory ingestion
    submissionId: Id of the submission
  Responses:
    HTTP 200: Zip file of Images of this submission
    HTTP 403: Operation not permitted
    HTTP 404: Submission not found
  */
  function getImagesZipInventoryIngestionDownloads (inventoryIngestionId, submissionId) {
    return new Promise(function (resolve, reject) {
      try {
        if (!inventoryIngestionId) {
          throw new Error('inventoryIngestionId: Missing parameter')
        }
        if (inventoryIngestionId && !(typeof inventoryIngestionId === 'string')) {
          throw new Error('inventoryIngestionId: Wrong type: Got "' + (typeof inventoryIngestionId) + '", but expected: "string"')
        }
        if (!submissionId) {
          throw new Error('submissionId: Missing parameter')
        }
        if (submissionId && !(typeof submissionId === 'string')) {
          throw new Error('submissionId: Wrong type: Got "' + (typeof submissionId) + '", but expected: "string"')
        }
      } catch (error) {
        var err = new Error()
        err.message = error.message || 'Unknown Validation Error'
        err.name = 'Validation Error'
        reject(err)
        return
      }
      var parameters = {}
      var path = '/inventoryIngestion/{inventoryIngestionId}/submissions/{submissionId}/download/images'
      path = path.replace('{' + 'inventoryIngestionId' + '}', inventoryIngestionId)
      path = path.replace('{' + 'submissionId' + '}', submissionId)
      Api
        .request({
          url: path,
          method: 'get',
          headers: {
            'content-type': 'application/json'
          },
          params: parameters
        })
        .then(function (response) {
          resolve(response)
        })
        .catch(function (error) {
          var err = new Error()
          err.message = error.message || 'Unknown XHR Error'
          err.name = 'XHR Error'
          err.response = error.response
          reject(err)
        })
        .catch(err => {
          
        })
    })
  }
  /*
  Operation: getBinariesZip
  Get all binaries as a zip file
  Parameters:
    inventoryIngestionId: Id of the inventory ingestion
    submissionId: Id of the submission
  Responses:
    HTTP 200: Zip file of Binaries of this submission
    HTTP 403: Operation not permitted
    HTTP 404: Submission not found
  */
  function getBinariesZipInventoryIngestionDownloads (inventoryIngestionId, submissionId) {
    return new Promise(function (resolve, reject) {
      try {
        if (!inventoryIngestionId) {
          throw new Error('inventoryIngestionId: Missing parameter')
        }
        if (inventoryIngestionId && !(typeof inventoryIngestionId === 'string')) {
          throw new Error('inventoryIngestionId: Wrong type: Got "' + (typeof inventoryIngestionId) + '", but expected: "string"')
        }
        if (!submissionId) {
          throw new Error('submissionId: Missing parameter')
        }
        if (submissionId && !(typeof submissionId === 'string')) {
          throw new Error('submissionId: Wrong type: Got "' + (typeof submissionId) + '", but expected: "string"')
        }
      } catch (error) {
        var err = new Error()
        err.message = error.message || 'Unknown Validation Error'
        err.name = 'Validation Error'
        reject(err)
        return
      }
      var parameters = {}
      var path = '/inventoryIngestion/{inventoryIngestionId}/submissions/{submissionId}/download/binaries'
      path = path.replace('{' + 'inventoryIngestionId' + '}', inventoryIngestionId)
      path = path.replace('{' + 'submissionId' + '}', submissionId)
      Api
        .request({
          url: path,
          method: 'get',
          headers: {
            'content-type': 'application/json'
          },
          params: parameters
        })
        .then(function (response) {
          resolve(response)
        })
        .catch(function (error) {
          var err = new Error()
          err.message = error.message || 'Unknown XHR Error'
          err.name = 'XHR Error'
          err.response = error.response
          reject(err)
        })
        .catch(err => {
          
        })
    })
  }
  var ret = {}
  ret['getImagesZip'] = getImagesZipInventoryIngestionDownloads
  ret['getBinariesZip'] = getBinariesZipInventoryIngestionDownloads
  return ret
})()

module.exports = InventoryIngestionDownloads
